import { InfoIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const RulesFooter = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-4 mb-96 flex items-center justify-center gap-2 text-foreground-muted">
      <InfoIcon aria-hidden="true" size={16} />
      <span className="text-sm leading-5 font-medium">{t('rules.priority_legend')}</span>
    </div>
  );
};
